module.exports = __webpack_public_path__ + "img/telephone.e1ea5495.svg";